import { FC } from "react";
import { Trans } from "@lingui/macro";
import {
  StyledDropDownHeader,
  StyledDropDownHeaderText,
  SizeGuideLabel,
} from "./SmallSizeGuideHeader.styled";
import { RullerLengthIcon } from "@otrium/icons";
import { FlexProps } from "@otrium/core";

type StyledHeaderProps = Omit<FlexProps, "css">;

interface Props extends StyledHeaderProps {
  onOpenSizeGuide?: () => void;
}

const SmallSizeGuideHeader: FC<Props> = ({ onOpenSizeGuide, ...rest }) => {
  return (
    <StyledDropDownHeader {...rest}>
      <RullerLengthIcon width="24px" height="24px" />
      <StyledDropDownHeaderText variant="body.source.semibold14">
        <span>
          <Trans>pdp_size_fits_small_info</Trans>
          &nbsp;
        </span>
        <SizeGuideLabel onClick={onOpenSizeGuide}>
          <Trans>View size guide</Trans>
        </SizeGuideLabel>
      </StyledDropDownHeaderText>
    </StyledDropDownHeader>
  );
};

export default SmallSizeGuideHeader;
